export default __webpack_public_path__ + "static/media/game_mg_full_2x.4ef66270.jpg";